"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseConnection_1 = __importDefault(require("./BaseConnection"));
var configurationError_1 = __importStar(require("./errors/configurationError"));
var resolutionError_1 = __importStar(require("./errors/resolutionError"));
var FetchProvider_1 = __importDefault(require("./FetchProvider"));
var NamingService = /** @class */ (function (_super) {
    __extends(NamingService, _super);
    function NamingService(source, name) {
        var _this = _super.call(this) || this;
        _this.name = name;
        source = _this.normalizeSource(source);
        _this.ensureConfigured(source);
        _this.url = source.url;
        _this.provider = source.provider || new FetchProvider_1.default(_this.name, _this.url || '');
        _this.network = source.network;
        _this.registryAddress = source.registry;
        return _this;
    }
    NamingService.prototype.serviceName = function (domain) {
        return this.name;
    };
    NamingService.prototype.namehash = function (domain) {
        var _this = this;
        this.ensureSupportedDomain(domain);
        var parent = '0000000000000000000000000000000000000000000000000000000000000000';
        return '0x' + [parent]
            .concat(domain
            .split('.')
            .reverse()
            .filter(function (label) { return label; }))
            .reduce(function (parent, label) {
            return _this.childhash(parent, label);
        });
    };
    NamingService.prototype.record = function (domain, key) {
        return __awaiter(this, void 0, void 0, function () {
            var records;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.records(domain, [key])];
                    case 1:
                        records = _a.sent();
                        return [2 /*return*/, NamingService.ensureRecordPresence(domain, key, records[key])];
                }
            });
        });
    };
    NamingService.prototype.ensureSupportedDomain = function (domain) {
        if (!this.isSupportedDomain(domain)) {
            throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.UnsupportedDomain, {
                domain: domain,
            });
        }
    };
    NamingService.prototype.ignoreResolutionErrors = function (codes, promise) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, promise];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        if (codes.some(function (code) { return _this.isResolutionError(error_1, code); })) {
                            return [2 /*return*/, undefined];
                        }
                        else {
                            throw error_1;
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NamingService.prototype.isResolutionError = function (error, code) {
        return error instanceof resolutionError_1.default && (!code || error.code === code);
    };
    NamingService.ensureRecordPresence = function (domain, key, value) {
        if (value) {
            return value;
        }
        throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.RecordNotFound, {
            recordName: key,
            domain: domain,
        });
    };
    NamingService.prototype.ensureConfigured = function (source) {
        if (!source.network) {
            throw new configurationError_1.default(configurationError_1.ConfigurationErrorCode.UnspecifiedNetwork, {
                method: this.name,
            });
        }
        if (!source.url && !source.provider) {
            throw new configurationError_1.default(configurationError_1.ConfigurationErrorCode.UnspecifiedUrl, {
                method: this.name,
            });
        }
    };
    NamingService.prototype.constructRecords = function (keys, values) {
        var records = {};
        keys.forEach(function (key, index) {
            var value = (values instanceof Array ? values[index] : values === null || values === void 0 ? void 0 : values[key]) || '';
            records[key] = value;
        });
        return records;
    };
    return NamingService;
}(BaseConnection_1.default));
exports.default = NamingService;
